import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'account-'

export default {
  path: '/account',
  name: 'account',
  redirect: {
    name: `${pre}index`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'index',
      name: `${pre}index`,
      meta: {
        ...meta,
        title: '用户设置',
      },
      component: () => import('@/views/account/index'),
    },
  ],
}
